import { requester } from "App";
import CustomButton from "components/buttons/CustomButton";
import Container from "layouts/container/Container";
import { useEffect, useState } from "react";

function Test() {
    const [isMounted, setMounted] = useState(false);
    useEffect(() => {
        setMounted(true);
    }, [])

    useEffect(() => {
        if (isMounted) {
            requester.findAllByConfirmYnIsTrue((result) => {
                console.log(result.data);
            })
        }

    }, [isMounted])
    const onClick = () => {
        let data = {
            title: "제목1",
            content: "사장님이 화났어요",
            storeId: "3eab0a4e-7105-48a3-a848-c25203d81569"
        }

        requester.createReport(data, (result) => {
            console.log(result);
        })
    }

    return (
        <Container>
            <CustomButton text={"테스트 생성"} onClick={onClick} />
        </Container>
        
    );
}

export default Test;